const ONB_BANK_ACCOUNT_OPEN = 'ONB_BANK_ACCOUNT_OPEN';
const ONB_BANK_ACCOUNT_OPEN_PROMO = 'ONB_BANK_ACCOUNT_OPEN_PROMO';
const ONB_ROBO = 'ONB_ROBO';
const ONB_BANK_DEPOSIT_OPEN = 'ONB_BANK_DEPOSIT_OPEN';
const ONB_PAYROLL_ACCOUNT_OPEN = 'ONB_PAYROLL_ACCOUNT_OPEN';
const ONB_SAVINGS_ACCOUNT_WELCOME = 'ONB_SAVINGS_ACCOUNT_WELCOME';
const ONB_VALUES_ACCOUNT_WELCOME = 'ONB_VALUES_ACCOUNT_WELCOME';
const ONB_SAVINGS_ACCOUNT = 'ONB_SAVINGS_ACCOUNT';
const ONB_BANK_PAID_ACCOUNT_OPEN = 'ONB_BANK_PAID_ACCOUNT_OPEN';

export default {
    ONB_BANK_DEPOSIT_OPEN,
    ONB_BANK_ACCOUNT_OPEN,
    ONB_BANK_ACCOUNT_OPEN_PROMO,
    ONB_BANK_PAID_ACCOUNT_OPEN,
    ONB_PAYROLL_ACCOUNT_OPEN,
    ONB_SAVINGS_ACCOUNT_WELCOME,
    ONB_VALUES_ACCOUNT_WELCOME,
    ONB_SAVINGS_ACCOUNT,
    ONB_ROBO,
};
